import { addRolesToUser, createUser } from '@infuse/api/iam/user';
import { useGenericCreateUser } from './generic/useGenericCreateUser';
import { addRolesToOrganisationUser, createOrganisationUser } from '@infuse/api/iam/organisation';
import { UserLevel } from '@infuse/iam/user/type';
import { addRolesToTenantUser, createTenantUser } from '@infuse/api/iam/tenant';
import { useCurrentUserStore } from '@infuse/iam/user/store';

export const useCreateUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericCreateUser({
      apiFn: createOrganisationUser,
      roleApiFn: addRolesToOrganisationUser,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericCreateUser({
      apiFn: createTenantUser,
      roleApiFn: addRolesToTenantUser,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericCreateUser({
    apiFn: createUser,
    roleApiFn: addRolesToUser
  });
};
